<template>
  <div class="item-wrapper">
    <input
      type="checkbox"
      class="item-wrapper__checkbox"
      v-if="item.id && isMassEdit"
      v-model="isChecked"
    />
    <router-link
      class="items-container__item item"
      :class="{ 'add-new-item': item.isNewRoute }"
      :to="item.isNewRoute ? { name: 'add-blacklist' } : { name: 'blacklist', params: {id: item.id}}"
    >
      <div class="item__row item__title">
        <span v-if="!item.isNewRoute" title="vehicleReg">{{ item.vehicleReg }}</span>
        <span title="partner" v-if="item.partnerName && !item.isNewRoute">{{ item.partnerName }}</span>
        <span v-if="item.isNewRoute">{{ item.name }}</span>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
    isMassEdit: Boolean,
    onClickCheckbox: Function,
    checked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isChecked: this.checked,
    };
  },
  watch: {
    isChecked() {
      this.onClickCheckbox(this.item.id, this.isChecked);
    },
  },
  updated() {
    this.isChecked = this.checked;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/blacklist/ListItemTemplate.vue